import { useCallback, useEffect } from "react";

import * as Sentry from "@sentry/react";
import { SpinnerCenter } from "@shapr3d/frontend-lib";

import ChargebeeCheckout from "../components/ChargebeeCheckout/ChargebeeCheckout";
import { CheckoutErrorModal } from "../components/ChargebeeCheckout/components/CreateCheckoutErrorModal/CreateCheckoutErrorModal";
import { PaddleBillingCheckout } from "../components/PaddleBillingCheckout/PaddleBillingCheckout";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import { BrowserLocaleIntlProvider } from "../contexts/BrowserLocaleIntlProvider";
import useNavigation from "../hooks/navigation";
import { paymentPlatformSentryTag } from "../hooks/useAccount";
import { useCreateCheckout, useInitialPeriod } from "../hooks/useCheckout";

export const CheckoutRouter = () => {
  const initialPeriod = useInitialPeriod();
  const {
    mutate: mutateCreateCheckout,
    data: createCheckoutData,
    isPending: isCreateCheckoutPending,
    isError: isCreateCheckoutError,
    error: createCheckoutError,
  } = useCreateCheckout();
  const navigate = useNavigation();
  const onErrorClose = useCallback(() => navigate.goToSubscription(), [navigate]);

  useEffect(() => {
    mutateCreateCheckout({ period: initialPeriod });
  }, [mutateCreateCheckout, initialPeriod]);

  useEffect(() => {
    if (!createCheckoutData) {
      return;
    }

    if (createCheckoutData.checkoutType === "paddle_one_time") {
      Sentry.setTag(paymentPlatformSentryTag, "paddle_billing");
    } else {
      Sentry.setTag(paymentPlatformSentryTag, "chargebee");
    }
  }, [createCheckoutData]);

  if (isCreateCheckoutPending || (!createCheckoutData && !isCreateCheckoutError)) {
    return <SpinnerCenter />;
  }

  if (isCreateCheckoutError) {
    return <CheckoutErrorModal open error={createCheckoutError} onClose={onErrorClose} />;
  }

  if (createCheckoutData.checkoutType === "paddle_one_time") {
    return (
      <UnderMaintenanceOrChildren>
        <PaddleBillingCheckout
          prices={createCheckoutData.prices}
          customerId={createCheckoutData.paddleCustomerId}
        />
      </UnderMaintenanceOrChildren>
    );
  }

  return (
    <BrowserLocaleIntlProvider>
      <UnderMaintenanceOrChildren>
        <ChargebeeCheckout initialCheckoutData={createCheckoutData} />
      </UnderMaintenanceOrChildren>
    </BrowserLocaleIntlProvider>
  );
};
